export interface DataSet {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  owner: string | null;
  hidden: boolean;
  type: DataSetType;
}

export enum DataSetType {
  SOURCE = "SOURCE",
  CORPUS = "CORPUS",
  PIF = "PIF",
}
